import { render, staticRenderFns } from "./KatexMixedText.vue?vue&type=template&id=e53704e8&scoped=true&lang=pug&"
import script from "./KatexMixedText.vue?vue&type=script&lang=ts&"
export * from "./KatexMixedText.vue?vue&type=script&lang=ts&"
import style0 from "./KatexMixedText.vue?vue&type=style&index=0&id=e53704e8&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e53704e8",
  null
  
)

export default component.exports